import { render, staticRenderFns } from "./Bike.vue?vue&type=template&id=3d97e6ff&"
import script from "./Bike.vue?vue&type=script&lang=js&"
export * from "./Bike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Bike.vue"
export default component.exports